import type { Auth0ContextInterface } from '@auth0/auth0-react';
import { z } from 'zod';

import { createSingleHandler, FetchWrapper } from '../helpers/fetch-wrapper';
import type { StoreCreateInput } from './stores';

const baseUrl = `${import.meta.env.VITE_SERVER_URL}/payments`;

export class StripeService {
  fetchWrapper: FetchWrapper;

  constructor(tokenAccessor: Auth0ContextInterface['getAccessTokenSilently']) {
    this.fetchWrapper = new FetchWrapper(tokenAccessor);
  }

  createCheckoutSession(parameters: StoreCreateInput) {
    return this.fetchWrapper
      .post(`${baseUrl}/checkout-session`, parameters)
      .then(createSingleHandler(CreateCheckoutSessionResultSchema));
  }

  createPortalSession(storeId: string) {
    return this.fetchWrapper
      .post(`${baseUrl}/${storeId}/portal-session`, {})
      .then(createSingleHandler(CreatePortalSessionResultSchema));
  }
}

const CreateCheckoutSessionResultSchema = z.object({
  session_id: z.string(),
  session_url: z.string(),
});

// Exported so data/api-contract.test.ts can assert it covers the Go
// PortalSessionResponse; the app redirects straight to `portal_url`, so a
// rename on the Go side breaks billing with no other signal.
export const CreatePortalSessionResultSchema = z.object({
  portal_url: z.string(),
});
